import './PeriscopeView.scss';
import { BulkAddSelectionContextWidget } from './bulk-add/BulkAddSelectionContextWidget';
import { PeriscopeSummaryList } from './PeriscopeSummaryList';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { ViewArea } from '@ui/general';
import { useOnMount, usePeriscopeActions, usePeriscopeCount, usePeriscopeReset } from '@hooks';
const periscopeMaxWidth = 910;
const periscopeMinWidth = 300;
function getPeriscopeFromPath(path) {
    const pathParts = path.split('/');
    const [, , type, id, displayName] = pathParts;
    return {
        id: Number(id),
        name: displayName ? decodeURIComponent(displayName) : '',
        type: type
    };
}
export const PeriscopeView = ({ noPadding, skipOnMount }) => {
    const location = useLocation();
    const { openPeriscope } = usePeriscopeActions();
    const periscopeCount = usePeriscopeCount();
    const resetPeriscopes = usePeriscopeReset();
    useOnMount(() => {
        if (skipOnMount) {
            resetPeriscopes();
            return;
        }
        if (periscopeCount === 0) {
            openPeriscope(Object.assign({}, getPeriscopeFromPath(location.pathname)));
        }
        return () => {
            resetPeriscopes();
        };
    });
    const periscopeWidth = {
        maxWidth: periscopeCount * periscopeMaxWidth,
        minWidth: periscopeCount * periscopeMinWidth
    };
    return (React.createElement(ViewArea, { className: 'periscope-view', fullHeight: true, fullWidth: true, noPadding: noPadding },
        React.createElement("div", { className: 'periscope-list', style: periscopeWidth },
            React.createElement(BulkAddSelectionContextWidget, null),
            React.createElement("div", { className: 'periscope-container' },
                React.createElement(PeriscopeSummaryList, null)))));
};
